export default "__VITE_ASSET__FAo5bSLu__"